/** The recent runs as a strip, and "4 h ago · 27 rows · Written" under it, from the runs omnium made (tries left out). */

import { RunStrip } from "@/components/kit";
import { listRuns } from "@/lib/integrations/api";
import { ago, runStatus } from "@/lib/integrations/words";

import { useKeyed } from "./hooks";

export function LastRun({ code, lastRunAt, now }: { code: string; lastRunAt: string | null; now: number }) {
  const runs = useKeyed(`${code}|${lastRunAt}`, () => listRuns(code, 12));
  const real = (runs.data ?? []).filter((run) => run.via !== "try");
  const newest = real[0];
  if (!newest) {
    return <RunStrip runs={[]} caption={!runs.data && runs.busy ? "Reading runs…" : lastRunAt ? ago(lastRunAt, now) : "No runs yet"} />;
  }
  return (
    <RunStrip
      runs={real}
      caption={`${ago(newest.finishedAt ?? newest.createdAt, now)} · ${newest.rowsCollected.toLocaleString()} rows · ${runStatus(newest.status).word}`}
    />
  );
}
